import mapChartDataFromApi from 'rtkQuery/sharespro/mapper/shared/mapChartDataFromApi';
import mapCurrencyFromApi from 'rtkQuery/sharespro/mapper/shared/mapCurrencyFromApi';

const mapPortfolioChartDataFromApi = (
  data: ApiFetchPortfolioChartResponseData
): PortfolioChartData => {
  return {
    currency: mapCurrencyFromApi(data.currency),
    chartData: mapChartDataFromApi(data.chart_date),
    balance: data.balance_last_day,
    balanceChange: data.balance_change,
    balanceChangePercent: data.balance_change_pc,
  };
};

export default mapPortfolioChartDataFromApi;
